module.exports = __webpack_public_path__ + "img/responsive.430a73dc.svg";